module.exports = __webpack_public_path__ + "static/media/brand-icons.13db00b7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/brand-icons.eot
// module id = ./src/styling/theme/assets/fonts/brand-icons.eot
// module chunks = 0